/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiCustomListsDtoCustomListItemFieldValueDto } from './WebApiCustomListsDtoCustomListItemFieldValueDto';
import {
    WebApiCustomListsDtoCustomListItemFieldValueDtoFromJSON,
    WebApiCustomListsDtoCustomListItemFieldValueDtoFromJSONTyped,
    WebApiCustomListsDtoCustomListItemFieldValueDtoToJSON,
} from './WebApiCustomListsDtoCustomListItemFieldValueDto';

/**
 * 
 * @export
 * @interface WebApiCustomListsDtoCustomListBulkItemDto
 */
export interface WebApiCustomListsDtoCustomListBulkItemDto {
    /**
     * 
     * @type {Array<WebApiCustomListsDtoCustomListItemFieldValueDto>}
     * @memberof WebApiCustomListsDtoCustomListBulkItemDto
     */
    fieldValues?: Array<WebApiCustomListsDtoCustomListItemFieldValueDto> | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiCustomListsDtoCustomListBulkItemDto
     */
    memberId?: number;
}

/**
 * Check if a given object implements the WebApiCustomListsDtoCustomListBulkItemDto interface.
 */
export function instanceOfWebApiCustomListsDtoCustomListBulkItemDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiCustomListsDtoCustomListBulkItemDtoFromJSON(json: any): WebApiCustomListsDtoCustomListBulkItemDto {
    return WebApiCustomListsDtoCustomListBulkItemDtoFromJSONTyped(json, false);
}

export function WebApiCustomListsDtoCustomListBulkItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiCustomListsDtoCustomListBulkItemDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fieldValues': !exists(json, 'fieldValues') ? undefined : (json['fieldValues'] === null ? null : (json['fieldValues'] as Array<any>).map(WebApiCustomListsDtoCustomListItemFieldValueDtoFromJSON)),
        'memberId': !exists(json, 'memberId') ? undefined : json['memberId'],
    };
}

export function WebApiCustomListsDtoCustomListBulkItemDtoToJSON(value?: WebApiCustomListsDtoCustomListBulkItemDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fieldValues': value.fieldValues === undefined ? undefined : (value.fieldValues === null ? null : (value.fieldValues as Array<any>).map(WebApiCustomListsDtoCustomListItemFieldValueDtoToJSON)),
        'memberId': value.memberId,
    };
}

